module.exports = __webpack_public_path__ + "assets/filters_new_large-d25382.svg";